import { DateTime } from 'luxon';
import CardFareApiModel from './card-fare.api-model';
import type ICardCharge from '../../../models/tap-and-go/card-charge.model';

export default class CardChargeApiModel {
  public static mapToBusinessModel(apiModel: CardChargeApiModel): ICardCharge {
    return {
      id: apiModel.id,
      amountInOre: apiModel.amountInOre,
      netAmountInOre: apiModel.netAmountInOre,
      createdDateTime: DateTime.fromISO(apiModel.createdDateTime),
      taxInOre: apiModel.taxInOre,
      fares: apiModel.fares.map((x) => CardFareApiModel.mapToBusinessModel(x)),
    };
  }

  public id!: string;
  public createdDateTime!: string;
  public amountInOre!: number;
  public netAmountInOre!: number;
  public taxInOre!: number;
  public fares!: CardFareApiModel[];
}
